import { useState } from "react";
import { Input, message } from "antd";
import { formatCurrency } from "../Helpers/formatters";

export const EditableCell = ({ value: initialValue, onSave }) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(initialValue);

  const toggleEdit = () => {
    setEditing(!editing);
  };

  const save = async () => {
    try {
      const newPrice = parseFloat(value);
      if (isNaN(newPrice)) {
        message.error("El valor ingresado no es válido.");
        return;
      }
      await onSave(newPrice);
      toggleEdit();
      message.success("Precio actualizado");
    } catch (error) {
        console.error(error)
      message.error("Error al actualizar el precio");
    }
  };

  return editing ? (
    <Input
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onPressEnter={save}
      onBlur={save}
      autoFocus
    />
  ) : (
    <div onDoubleClick={toggleEdit} style={{ cursor: "pointer" }}>
      {formatCurrency(value)}
    </div>
  );
};
